import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'

// Two-column panel layout (used by Scheduling and Receptors show pages)
export const ShowPageDetailsPanel = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  margin-bottom: 32px;
`

export const ShowPageDetailsPanelLeft = styled.div`
  flex: 1;
  padding: 5px 24px 20px 0;
  display: flex;
  flex-direction: column;
`

export const ShowPageDetailsPanelRight = styled.div`
  flex: 1;
  padding: 16px 20px;
  // Restored: dropped in 062287a28c (AP-19684, account management dashboard)
  // alongside that commit's flex reflow, which left the border-radius below
  // rounding nothing. The flex changes were intentional; this was not.
  background: ${palette.neutral[30]};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
`
